(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
if (!customElements.get('lm-atc-ranker')) {
  customElements.define('lm-atc-ranker', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.rank(), { once: true, signal: this.controller.signal });
      } else {
        queueMicrotask(() => this.rank());
      }
    }

    disconnectedCallback() { this.controller.abort(); }

    /* DEV-288: every way out tells the feed (assets/lm-collection.js) that the order is final, so it never waits for a timeout */
    done(fallback) {
      if (fallback) {
        this.dataset.fallback = 'true';
        /* T4 2026-09-30: without the ranked list the feed takes the shop's pages 2, 3 ..., which never hold the products page 1
           pushed off (Midi showed 44 of 53); they are put at the end of page 1 so none is lost */
        const section = this.closest('.shopify-section');
        const grid = section?.querySelector('product-list.product-list');
        if (grid) {
          const onPage = new Set([...grid.querySelectorAll('product-card[handle]')].map(card => card.getAttribute('handle')));
          section.querySelectorAll('template[data-lm-extra]').forEach((tpl) => {
            tpl.content.querySelectorAll('product-card[handle]').forEach((card) => {
              if (onPage.has(card.getAttribute('handle'))) return;
              const clone = document.importNode(card, true);
              clone.removeAttribute('reveal-js');
              grid.append(clone);
            });
            tpl.remove();
          });
        }
      }
      this.dispatchEvent(new CustomEvent('lm:ranked', { bubbles: true }));
    }

    async rank() {
      try { await this.rankInner(); } finally { if (!this.dataset.complete && !this.dataset.fallback) this.done(true); }
    }

    async rankInner() {
      const url = new URL(location.href);
      if (url.searchParams.has('sort_by') || this.dataset.complete) return;
      const section = this.closest('.shopify-section');
      const grid = section?.querySelector('product-list.product-list');
      const source = this.querySelector('[data-atc-ranking]');
      if (!grid || !source) return;
      let ranking;
      try { ranking = JSON.parse(source.textContent); } catch { return; }
      const age = Date.now() - Date.parse(ranking.generatedAt);
      if (!Number.isFinite(age) || age < -300000 || age > 172800000 || !ranking.handles.length) return;
      const pages = Number(this.dataset.pages);
      const page = Number(this.dataset.page);
      const size = Number(this.dataset.size);
      if (!Number.isInteger(pages) || pages < 1 || pages > 50 || !Number.isInteger(page) || !Number.isInteger(size) || size < 1) return;
      const read = (root) => {
        const meta = root.querySelector('[data-atc-slots]');
        /* DEV-432: Sponsored cards stay where the server put them and their products are left out of the ranking */
        const cards = [...root.querySelectorAll('product-list.product-list > product-card[handle]:not([data-lm-sponsored])')];
        const sponsored = [...root.querySelectorAll('product-list.product-list > [data-lm-sponsored]')].map(node => node.getAttribute('data-lm-sponsored'));
        /* DEV-293 (T4): cards that the server-side page 1 order pushed off page 1 */
        root.querySelectorAll('template[data-lm-extra]').forEach((tpl) => cards.push(...tpl.content.querySelectorAll('product-card[handle]')));
        if (!meta) throw new Error('Missing collection page');
        const slots = JSON.parse(meta.textContent);
        if (!Array.isArray(slots)) throw new Error('Invalid collection page');
        let featured = [];
        try { featured = JSON.parse(root.querySelector('[data-atc-featured]')?.textContent || '[]'); } catch {}
        let fresh = [];
        try { fresh = JSON.parse(root.querySelector('[data-atc-new]')?.textContent || '[]'); } catch {}
        let ids = [];
        try { ids = JSON.parse(root.querySelector('[data-atc-slot-ids]')?.textContent || '[]'); } catch {}
        return { slots, ids: Array.isArray(ids) ? ids : [], cards, sponsored, featured: Array.isArray(featured) ? featured : [], fresh: Array.isArray(fresh) ? fresh : [] };
      };
      try {
        const results = new Array(pages);
        results[page - 1] = read(section);
        const pending = Array.from({ length: pages }, (_, i) => i + 1).filter(i => i !== page);
        await Promise.all(Array.from({ length: Math.min(3, pending.length) }, async () => {
          while (pending.length) {
            const n = pending.shift();
            const endpoint = new URL(url);
            endpoint.searchParams.set('section_id', this.dataset.section);
            endpoint.searchParams.set('page', n);
            let response = await fetch(endpoint, { signal: this.controller.signal, credentials: 'same-origin' }).catch(() => null);
            /* a busy store answers 429: one retry after the wait it asks for (at most 5 s) */
            if (!response || !response.ok) {
              const wait = response ? Math.min(5, Number(response.headers.get('Retry-After')) || 1.5) : 1.5;
              await new Promise(resolve => setTimeout(resolve, wait * 1000));
              response = await fetch(endpoint, { signal: this.controller.signal, credentials: 'same-origin' });
            }
            if (!response.ok) throw new Error('Collection unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const marker = doc.querySelector('lm-atc-ranker');
            if (Number(marker?.dataset.page) !== n || Number(marker?.dataset.pages) !== pages) throw new Error('Collection changed');
            results[n - 1] = read(doc);
          }
        }));
        if (!this.isConnected || this.controller.signal.aborted || location.href !== url.href) return;
        const sponsored = new Set(results.flatMap(result => result.sponsored));
        const slots = results.flatMap(result => result.slots).filter(handle => !sponsored.has(handle));
        if (slots.length !== new Set(slots).size) throw new Error('Duplicate products');
        const cards = new Map(results.flatMap(result => result.cards).map(card => [card.getAttribute('handle'), card]));
        /* cro.atc_order: product ids in ATC order, matched to handles through every page's ids */
        let order = ranking.handles;
        if (Array.isArray(ranking.ids) && ranking.ids.length) {
          const byId = new Map();
          results.forEach(result => result.ids.forEach((id, i) => byId.set(String(id), result.slots[i])));
          order = ranking.ids.map(gid => byId.get(String(gid).split('/').pop())).filter(Boolean);
        }
        const scores = new Map(order.map((handle, index) => [handle, index]));
        const ordered = slots.map((handle, index) => ({ handle, index, rank: cards.has(handle) ? (scores.get(handle) ?? Infinity) : Infinity }))
          .sort((a, b) => a.rank - b.rank || a.index - b.index);
        /* DEV-293: featured products take places 1, 5, 9... in their ATC order; the rest keep theirs.
           DEV-295 (Developeris B, 2026-09-30): the two newest new products (no ATC data yet) take places 4 and 10. */
        const featured = new Set(results.flatMap(result => result.featured).filter(handle => !sponsored.has(handle)));
        const inList = new Set(ordered.map(item => item.handle));
        /* with cro.atc_order (ranking.ids) the list already places new products: only featured are moved */
        const newest = Array.isArray(ranking.ids) && ranking.ids.length ? [] : [...new Map(results.flatMap(result => result.fresh || [])).entries()]
          .filter(([handle]) => !featured.has(handle) && !sponsored.has(handle) && inList.has(handle))
          .sort((a, b) => b[1] - a[1]).slice(0, 2).map(([handle]) => handle);
        if (featured.size || newest.length) {
          const top = ordered.filter(item => featured.has(item.handle));
          const fresh = newest.map(handle => ordered.find(item => item.handle === handle));
          const rest = ordered.filter(item => !featured.has(item.handle) && !newest.includes(item.handle));
          ordered.length = 0;
          while (top.length || rest.length || fresh.length) {
            const i = ordered.length;
            if ((i === 3 || i === 9) && fresh.length) ordered.push(fresh.shift());
            else if (i % 4 === 0 && top.length) ordered.push(top.shift());
            else if (rest.length) ordered.push(rest.shift());
            else ordered.push(top.length ? top.shift() : fresh.shift());
          }
        }
        const selected = ordered.slice((page - 1) * size, page * size).map(item => cards.get(item.handle)).filter(Boolean);
        /* DEV-288: the infinite feed (assets/lm-collection.js) takes the next and previous pages from this ranked list */
        this.ordered = ordered.map(item => cards.get(item.handle)).filter(Boolean);
        const promos = [...grid.children].filter(child => child.tagName !== 'PRODUCT-CARD' || child.hasAttribute('data-lm-sponsored')).map(node => ({ node, position: [...grid.children].indexOf(node) }));
        const fragment = document.createDocumentFragment();
        for (const card of selected) {
          const clone = document.importNode(card, true);
          clone.removeAttribute('reveal-js');
          fragment.append(clone);
        }
        for (const { node, position } of promos) fragment.insertBefore(node, fragment.children[position] || null);
        grid.replaceChildren(fragment);
        this.dataset.complete = 'true';
        grid.dataset.atcRanked = 'true';
        this.dispatchEvent(new CustomEvent('lm:ranked', { bubbles: true }));
      } catch (error) {
        this.controller.abort();
        this.done(true);
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
